import React from "react";
import { Container, Row, Col } from "shards-react";
import Invoices from "../components/invoicing/Invoices";

const InvoincesView = props => {
  const { id } = props.match.params;

  return (
    <Container fluid className="main-content-container px-4">
      <Row>
        <Col className="p-2">
          <Invoices client_id={id} />
        </Col>
      </Row>
    </Container>
  );
};

export default InvoincesView;
